module.exports = __webpack_public_path__ + "static/img/1en.c2c8205.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/realme/1en.png
// module id = TyDE
// module chunks = 0